import React from 'react';
import './ProductSection.css';

const ProductSection: React.FC = () => {
  return (
    <section className="product-section">
      <div className="product-background">
        <div className="product-gradient"></div>
      </div>
      
      <div className="product-container">
        {/* Notification Bar */}
        <div className="notification-bar">
          <span className="notification-text">Boost your productivity</span>
        </div>
        
        {/* Content Frame */}
        <div className="content-frame">
          <div className="text-content">
            <h2 className="product-heading">A more effective way to track progress</h2>
            <p className="product-description">
              Effortlessly turn your ideas into a fully functional, responsive, 
              no-code SaaS website in just minutes with the set of free components for Framer.
            </p>
          </div>
          
          {/* Product Image */}
          <div className="product-image">
            <img src="/section-2-banner.svg" alt="Product Dashboard" className="product-banner" />
          </div>
          
          {/* Feature Grid */}
          <div className="feature-grid">
            <div className="feature-card">
              <div className="feature-icon ecosystem-icon">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <path d="M12 2L13.09 8.26L20 9L13.09 9.74L12 16L10.91 9.74L4 9L10.91 8.26L12 2Z" fill="currentColor"/>
                </svg>
              </div>
              <h3 className="feature-title">One unified addressbook</h3>
              <div className="feature-content">
                <p className="feature-description">One unified address book</p>
                <button className="feature-button">
                  <span>Learn more</span>
                  <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                    <path d="M7.5 5L12.5 10L7.5 15" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </button>
              </div>
            </div>
            
            <div className="feature-card">
              <div className="feature-icon lock-icon">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <rect x="3" y="11" width="18" height="11" rx="2" ry="2" fill="currentColor"/>
                  <path d="M7 11V7a5 5 0 0 1 10 0v4" stroke="white" strokeWidth="2"/>
                </svg>
              </div>
              <h3 className="feature-title">Secure data encryption</h3>
              <div className="feature-content">
                <p className="feature-description">Ensure your data's safety with top-tier encryption.</p>
                <button className="feature-button">
                  <span>Learn more</span>
                  <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                    <path d="M7.5 5L12.5 10L7.5 15" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </button>
              </div>
            </div>
            
            <div className="feature-card">
              <div className="feature-icon target-icon">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <circle cx="12" cy="12" r="10" fill="currentColor"/>
                  <circle cx="12" cy="12" r="6" fill="white"/>
                  <circle cx="12" cy="12" r="2" fill="currentColor"/>
                </svg>
              </div>
              <h3 className="feature-title">Goal setting and tracking</h3>
              <div className="feature-content">
                <p className="feature-description">Set and track goals with manageable task breakdowns.</p>
                <button className="feature-button">
                  <span>Learn more</span>
                  <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                    <path d="M7.5 5L12.5 10L7.5 15" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </button>
              </div>
            </div>
            
            <div className="feature-card">
              <div className="feature-icon notifications-icon">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9" fill="currentColor"/>
                  <path d="M13.73 21a2 2 0 0 1-3.46 0" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </div>
              <h3 className="feature-title">Customizable notifications</h3>
              <div className="feature-content">
                <p className="feature-description">Get alerts on tasks and deadlines that matter most.</p>
                <button className="feature-button">
                  <span>Learn more</span>
                  <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                    <path d="M7.5 5L12.5 10L7.5 15" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProductSection; 